import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import BrandLogo from "@/components/BrandLogo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Register() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const { register } = useAuth();
  const [token, setToken] = useState("");
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const t = params.get("token");
    if (t) setToken(t);
  }, [params]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await register(email, password, name, token);
    setLoading(false);
    if (res.ok) {
      toast.success("Account created");
      nav("/dashboard");
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center p-6 bg-background text-foreground">
      <div className="w-full max-w-md">
        <BrandLogo />
        <h1 className="mt-10 text-4xl font-bold tracking-tight">Set up your account</h1>
        <p className="mt-2 text-muted-foreground text-sm">Complete the invite from your school administrator.</p>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <Label className="text-[0.65rem] tracking-[0.2em] uppercase text-muted-foreground">Invite token</Label>
            <Input data-testid="register-token" value={token} onChange={(e) => setToken(e.target.value)} className="mt-1.5 h-12 rounded-2xl" required />
          </div>
          <div>
            <Label className="text-[0.65rem] tracking-[0.2em] uppercase text-muted-foreground">Full name</Label>
            <Input data-testid="register-name" value={name} onChange={(e) => setName(e.target.value)} className="mt-1.5 h-12 rounded-2xl" required />
          </div>
          <div>
            <Label className="text-[0.65rem] tracking-[0.2em] uppercase text-muted-foreground">Email</Label>
            <Input data-testid="register-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 h-12 rounded-2xl" required />
          </div>
          <div>
            <Label className="text-[0.65rem] tracking-[0.2em] uppercase text-muted-foreground">Password</Label>
            <Input data-testid="register-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 h-12 rounded-2xl" required minLength={8} />
          </div>
          <Button data-testid="register-submit" disabled={loading} className="w-full h-12 rounded-2xl">
            {loading ? "Creating…" : "Create account"}
          </Button>
          <div className="text-xs text-muted-foreground text-center pt-2">
            Already have an account?{" "}
            <button type="button" onClick={() => nav("/login")} className="underline underline-offset-4 hover:text-foreground">
              Sign in
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
